import { useEffect, useState } from 'react';
import { adminApi } from '../../api/admin.js';

export default function Integrations() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);

  function refresh() { adminApi.integrations().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  function startEdit(it) {
    setEditing({ ...it, configText: JSON.stringify(typeof it.config === 'string' ? JSON.parse(it.config) : it.config, null, 2) });
  }

  async function save() {
    setError(null); setInfo(null);
    let parsed;
    try { parsed = JSON.parse(editing.configText); }
    catch { setError('Config must be valid JSON'); return; }
    try {
      await adminApi.upsertIntegration({
        kind: editing.kind, provider: editing.provider,
        config: parsed, isActive: editing.is_active,
      });
      setInfo('Saved');
      setEditing(null);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  return (
    <section>
      <header className="page-header"><h1>Integrations</h1></header>
      {error && <div className="alert error">{error}</div>}
      {info && <div className="alert info">{info}</div>}
      <div className="card">
        <p className="muted small">
          Integration adapters: SMTP (email), MinIO/S3 (storage), generic banking, generic tax/government compliance.
          Each row is a configurable connector — fill in the JSON config and toggle Active.
        </p>
        <table className="data-table">
          <thead><tr><th>Kind</th><th>Provider</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id}>
                <td><strong>{i.kind}</strong></td>
                <td><code>{i.provider}</code></td>
                <td><span className={`chip status-${i.is_active ? 'active' : 'cancelled'}`}>{i.is_active ? 'active' : 'inactive'}</span></td>
                <td><button className="btn ghost small" onClick={() => startEdit(i)}>Configure</button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="muted">No integration configs yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="card form-card">
          <header className="page-header">
            <h3>{editing.kind} · {editing.provider}</h3>
            <button className="btn ghost small" onClick={() => setEditing(null)}>✕</button>
          </header>
          <label className="checkbox-row">
            <input type="checkbox" checked={editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} />
            Active
          </label>
          <label>Config (JSON)
            <textarea rows={12} value={editing.configText} onChange={(e) => setEditing({ ...editing, configText: e.target.value })} className="rich-input" />
          </label>
          <div className="actions"><button className="btn primary" onClick={save}>Save</button></div>
        </div>
      )}
    </section>
  );
}
